package com.timacookies.pages.en

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("en/privacy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); }))
}

@Page("/en/privacy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("1-who-we-are") }) {
        org.jetbrains.compose.web.dom.Text("1. Who We Are")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This website is operated by Fatima Jovic – Tima Cookies, based in Switzerland. For any privacy-related inquiries, you can contact us at: ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Email:")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:timacookies.ch@gmail.com") {
            org.jetbrains.compose.web.dom.Text("timacookies.ch@gmail.com")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("2-introduction") }) {
        org.jetbrains.compose.web.dom.Text("2. Introduction")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We are committed to protecting your personal data and respecting your privacy. This Privacy Policy explains how we handle your information in accordance with applicable Swiss data protection laws, in particular the Federal Act on Data Protection (FADP).")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("3-data-we-collect") }) {
        org.jetbrains.compose.web.dom.Text("3. Data We Collect")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This website does not actively collect personal data. However, when you visit the website, certain technical data may be automatically collected by your browser or hosting provider, including:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("IP address")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Browser type and version")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Date and time of access")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Operating system")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This data is not used to identify individuals.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("4-cookies") }) {
        org.jetbrains.compose.web.dom.Text("4. Cookies")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This website does not use tracking or marketing cookies. Any cookies used are strictly necessary for the technical operation and security of the website.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("5-purpose-of-data-processing") }) {
        org.jetbrains.compose.web.dom.Text("5. Purpose of Data Processing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Any automatically collected data is used only for:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ensuring proper functioning of the website")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Maintaining security and stability")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Detecting and preventing misuse")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("6-legal-basis") }) {
        org.jetbrains.compose.web.dom.Text("6. Legal Basis")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Data processing is carried out in accordance with the Federal Act on Data Protection (FADP). Where applicable, processing is based on our legitimate interest in maintaining a secure and functional website.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("7-data-sharing") }) {
        org.jetbrains.compose.web.dom.Text("7. Data Sharing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We do not sell or share your personal data with third parties. Data may be processed by technical service providers (such as hosting providers) strictly for the purpose of operating the website.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("8-data-retention") }) {
        org.jetbrains.compose.web.dom.Text("8. Data Retention")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Technical data is retained only for as long as necessary to ensure the security and proper functioning of the website.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("9-your-rights") }) {
        org.jetbrains.compose.web.dom.Text("9. Your Rights")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Under the Federal Act on Data Protection (FADP), you have the right to:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Request access to your personal data")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Request correction of inaccurate data")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Request deletion of your data, where applicable")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To exercise your rights, please contact us using the details above.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("10-changes-to-this-policy") }) {
        org.jetbrains.compose.web.dom.Text("10. Changes to This Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update this Privacy Policy from time to time. Any changes will be published on this page.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("impressum-legal-notice") }) {
        org.jetbrains.compose.web.dom.Text("Impressum / Legal Notice")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Website Owner")
        }
        org.jetbrains.compose.web.dom.Text(" Fatima Jovic – Tima Cookies Rikonerstrasse 22 8307, Effretikon Switzerland")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Contact")
        }
        org.jetbrains.compose.web.dom.Text(" Email: ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:timacookies.ch@gmail.com") {
            org.jetbrains.compose.web.dom.Text("timacookies.ch@gmail.com")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Disclaimer")
        }
        org.jetbrains.compose.web.dom.Text(" The content of this website has been created with care. However, we do not guarantee the accuracy, completeness, or reliability of the content. We are not responsible for the content of external websites linked from this site.")
    }
}
